import { render, staticRenderFns } from "./inventoryGlassSizeBreakdownWidget.vue?vue&type=template&id=fbb5b5a6&"
import script from "./inventoryGlassSizeBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryGlassSizeBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports